import { Input, Table, Button, Popconfirm } from "antd";
import React, { useEffect, useState } from "react";
import { getCurrentDateTimeInFormat } from "../../../helper/date_helper";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import style from "antd/es/alert/style";

function FolderPath(props) {
  const [dataSource, setDataSource] = useState(
    props.initialData.map((item) => ({ ...item, isEditable: false })) || []
  );
  const [newRows, setNewRows] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    props.onFolderUpdate(newRows);
  }, [newRows, props]);

  const updateDataSource = (key, value, record) => {
    const updatedData = dataSource.map((item) =>
      item.key === record.key ? { ...item, [key]: value } : item
    );
    const newData = newRows.map((item) =>
      item.key === record.key ? { ...item, [key]: value } : item
    );
    setDataSource(updatedData);
    setNewRows(newData);
  };

  const validateFields = () => {
    let errors = {};
    dataSource.forEach((item) => {
      if (!item.description) {
        errors[item.key] = { ...errors[item.key], description: true };
      }
      if (!item.comment) {
        errors[item.key] = { ...errors[item.key], comment: true };
      }
    });
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleAdd = () => {
    if (validateFields()) {
      const newData = {
        key: Date.now().toString(),
        dataType: "Environment",
        dataSubType: props.environmentName,
        name: "Folder Path",
        description: "",
        comment: "",
        createdDate: getCurrentDateTimeInFormat(),
      };
      setDataSource([...dataSource, newData]);
      setNewRows((prev) => [...prev, newData]);
    }
  };

  const handleDelete = (key) => {
    setDataSource((prev) => prev.filter((item) => item.key !== key));
    setNewRows((prev) => prev.filter((item) => item.key !== key));
  };

  const handleDisplayNameChange = (value, record) => {
    updateDataSource("description", value, record);

    setValidationErrors((prev) => ({
      ...prev,
      [record.key]: { ...prev[record.key], description: !value },
    }));
  };

  const handlePathChange = (value, record) => {
    updateDataSource("comment", value, record);
    setValidationErrors((prev) => ({
      ...prev,
      [record.key]: { ...prev[record.key], comment: !value },
    }));
  };

  const columns = [
    {
      title: "",
      dataIndex: "delete",
      key: "delete",
      width: "4%",
      render: (_, record) => {
        const isInitialData = props.initialData.find(
          (item) => item.key === record.key
        );
        return (
          <span>
            {isInitialData ? (
              <span style={{ color: "gray" }}></span> // Disable delete for initial data
            ) : (
              <Popconfirm
                title="Are you sure?"
                onConfirm={() => handleDelete(record.key)}
              >
                <DeleteOutlined style={{ color: "red" }} />
              </Popconfirm>
            )}
          </span>
        );
      },
    },
    {
      title: "Display Name",
      dataIndex: "description",
      key: "description",
      width: "30%",
      editable: true,
      render: (_, record) => {
        const isNewRow = !props.initialData.find(
          (item) => item.key === record.key
        );
        return (
          <>
            <Input
              style={{
                fontSize: "12px",
                borderColor: validationErrors[record.key]?.description
                  ? "red"
                  : undefined,
              }}
              onChange={
                isNewRow
                  ? (e) => handleDisplayNameChange(e.target.value, record)
                  : undefined
              }
              value={record.description}
              placeholder="Enter Display Name"
              maxLength={50}
              disabled={!isNewRow} // Disable for existing rows
            />
            {validationErrors[record.key]?.description && (
              <div style={{ color: "red", fontSize: "12px" }}>
                Display Name is required
              </div>
            )}
          </>
        );
      },
    },
    {
      title: "Path",
      dataIndex: "comment",
      key: "comment",
      width: "50%",
      editable: true,
      render: (_, record) => {
        const isNewRow = !props.initialData.find(
          (item) => item.key === record.key
        );
        return (
          <>
            <Input
              style={{
                fontSize: "12px",
                borderColor: validationErrors[record.key]?.comment
                  ? "red"
                  : undefined,
              }}
              onChange={
                isNewRow
                  ? (e) => handlePathChange(e.target.value, record)
                  : undefined
              }
              value={record.comment}
              placeholder="Enter Folder Path"
              disabled={!isNewRow} // Disable for existing rows
            />
            {validationErrors[record.key]?.comment && (
              <div style={{ color: "red", fontSize: "12px" }}>
                Folder Path is required
              </div>
            )}
          </>
        );
      },
    },
  ];

  return (
    <div>
      <Table
        columns={columns}
        dataSource={dataSource}
        scroll={{ y: 300 }}
        pagination={false}
        className="custom-table-shadow"
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: 16,
          position: "sticky",
          bottom: 0,
        }}
      >
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={handleAdd}
          className="db-add"
        >
          Add Path
        </Button>
      </div>
    </div>
  );
}

export default FolderPath;
